
export function getExternalRideIdsFromTipsData(tips) {
  const getSportLinkId = (tip) => tip.sport_link;
  return tips? tips.map(getSportLinkId) : [];
}

export function groupTipsByAuthor(tips = null) {
  if (!tips) {
    return null;
  }

  let authorIdx = 0;
  const authorOrder = tips.reduce((order, tip) => {
    if (!order.has(tip.author_id)) {
      order.set(tip.author_id, authorIdx);
      ++authorIdx;
    }
    return order;
  }, new Map());

  const groupedTips = tips.reduce((byAuthor, tip) => {
    const idx = authorOrder.get(tip.author_id);
    if (!byAuthor[idx]) {
      byAuthor[idx] = [];
    }

    byAuthor[idx].push(tip);
    return byAuthor;
  }, []);

  return groupedTips;
}
/* Generate the data structure nessesary to display the tip data */
export function generateRidesTipBettingData(rides, rideIds) {
  const flattenedRides = (rides && rides.length > 0) ? [].concat(...rides.map(race => {
      const {
        course_name,
        date,
        name,
        race_stage
      } = race.race_summary;
      const skybetExtRaceId = race.race_summary.race_summary_reference.external_reference.find(extRef => extRef.ref === 'skybet')

      race.rides.forEach(ride => {
        ride.raceData = {
          course_name: course_name,
          date: date,
          race_name: name,
          race_skybetId: (skybetExtRaceId && skybetExtRaceId.value ? skybetExtRaceId.value : null),
          race_id: race.race_summary.race_summary_reference.id,
          raceStage: race_stage
        }
      });
      return race.rides;
    })) :
    [];

  const isTippedRide = ride => {
    return ride && rideIds.includes(ride.ride_reference.id.toString());
  }

  const getBetAndRideData = ride => {
    const {
      betting,
      ride_status,
      ride_reference,
      silk_filename,
      raceData
    } = ride;

    return {
      betting,
      ride_status,
      ride_reference,
      silk_filename,
      raceData
    };
  }

  const mapByInternalRideId = (rideMap, ride) => {
    return rideMap.set(ride.ride_reference.id, ride);
  }

  const ridesTipBettingData =
    flattenedRides.length > 0 ?
    flattenedRides
    .filter(isTippedRide)
    .map(getBetAndRideData)
    .reduce(mapByInternalRideId, new Map()) : new Map();

  return ridesTipBettingData;
}


// WEBPACK FOOTER //
// ./modules/Common/components/TipsWidget/tipUtils.js